<template>
    <div class="gooddetail">
        <div class="nav-topbar">
            <div class="mobiles-nav-list">
                <a class="nav-backs" @click="backs()"> 商城 </a>
                <a class="nav-items">产品详情</a>
            </div>
            <div class="nav-list">
                <a class="nav-backs" @click="backs()"> 商城 </a>
                <a class="nav-items">产品详情</a>
            </div>
        </div>
        <div class="detail-centers">
            <div class="detail-top">
                <div class="detail-pic">
                    <img :src="baseurl + detailInfo.image" width="100%" height="auto"></img>
                </div>
                <div class="detail-title">
                    <div class="name">{{ detailInfo.title }}</div>
                    <div class="goods-pr">
                        <span class="max">￥</span>{{ detailInfo.price[0] }}
                    </div>
                    <div class="goods-warehouse">发货地：浙江台州</div>
                </div>
            </div>
            <div class="title-top">产品定制操作:</div>
            <div class="goods-fabric">
                <div class="left">
                    <canvas :width="width" :height="height" id="c" ref="canvas"
                        style="border: 1px solid #ccc;"></canvas>
                </div>
                <!--
                <div class="right">
                    <div class="items">
                        <div class="font">操作区</div>
                    </div>
                    
                    <div class="items">
                        <div>向左</div>
                    </div>
                    <div class="items">
                        <el-slider v-model="value1" @change="handleChange"></el-slider>
                    </div>
                    <div class="items">
                        <div>向下</div>
                    </div>
                    <div class="items">
                        <el-slider v-model="value2" @change="handleChanges"></el-slider>
                    </div>
                    <div class="items">
                        <div>放大或者缩小</div>
                    </div>
                    <div class="items">
                        <el-slider v-model="value3" @change="handleChangess"></el-slider>
                    </div>
                </div>-->
            </div>
            <div class="goods-btns">
                <!--
                <el-button type="warning" @click="exportCanvas()">保存并提交</el-button>-->
            </div>
        </div>

    </div>
</template>

<script>
import ApiCon from '../util/Api/index'
import { fabric } from 'fabric';
export default {
    name: 'gooddetail',
    data() {
        return {
            id: this.$route.params.id,//31
            img:this.$route.params.img,
            diyImage: '',
            baseurl: 'https://www.sosunlive.com',
            canwidth: 0,
            canheight: 0,
            left: 0,
            top: 0,

            custom_params: '',
            width: 420,
            height: 420,
            canvas: '',
            detailInfo: {
                price: [0.00],
                image: ''
            },
            info: {

            }
        }
    },
    components: {

    },
    mounted() {
        let self = this
        self.canvas = new fabric.Canvas('c', {
            width: 420,
            height: 420
        })
         self.img = self.$route.params.img
         self.init()
        //new fabric.Text(text, { ...options });
    },
    created() {
        let self = this

    },

    methods: {
        getParam(paramName) {
            const url = window.location.href;
            const regex = new RegExp('[?&]' + paramName + '(=([^#&]*)|&|#|$)');
            const results = regex.exec(url);
            if (!results) return null;
            if (!results[2]) return '';
            return decodeURIComponent(results[2].replace(/\+/g, ' '));
        },
        backs() {
            let self = this
            self.$router.push("/store");
        },
        NavToStore() {
            let self = this
            self.$router.push("/store");
        },
        init() {
            let id = this.id;
            id = 31
            let self = this
            this.$api.mall.getGoodDetail(id).then((res) => {
                res.data.custom_front = res.data.custom_front
                self.custom_params = JSON.parse(res.data.wap_custom_params)
                console.log(self.custom_params)
                self.detailInfo = res.data
                let parms = {
                    width: self.width,
                    height: self.width,
                    left: 0,
                    top: 0
                }
                self.createImage(self.baseurl + '' + self.detailInfo.custom_front[0], parms)
                setTimeout(() => {
                    self.addimg()
                }, 500);
                document.body.scrollTop = 0
                document.documentElement.scrollTop = 0
            });
        },
        backs: function () {
            history.go(-1)
        },
        addimg() {
            let self = this
            let parms = {
                width: self.width,
                height: self.width,
                left: 0,
                top: 0
            }
            // self.createImage(self.info.image, parms)
            self.createImage(self.baseurl + '' + self.detailInfo.custom_front[1], parms)
            setTimeout(() => {
                self.addimgs()
            }, 500);
        },
        addimgs() {
            let self = this
            let parms = {
                width: self.width,
                height: self.width,
                left: 0,
                top: 0
            }
            self.createImage(self.baseurl + '' + self.detailInfo.custom_front[2], parms)
            setTimeout(() => {
                self.addimgss()
            }, 500);
        },
        discardActiveObject() {
            let that = this
            that.canvas.discardActiveObject().requestRenderAll();
        },
        addimgss() {
            ////img11.360buyimg.com/n5/s720x720_jfs/t1/302313/36/4532/247187/681dc39eF0e749606/fec0de1675340332.jpg.avif\
            let self = this
            let parms = {
                width: parseInt(self.custom_params.w),
                height: parseInt(self.custom_params.h),
                left: parseInt(self.custom_params.y),
                top: parseInt(self.custom_params.x)
            }
            // self.createImage(self.info.image, parms)
            self.createImage('https://www.sosunlive.com'+self.img,parms)
            setTimeout(() => {
                self.moveTo()
            }, 500);

        },
        moveTo() {
            let self = this
            self.discardActiveObject()
            const objects = self.canvas.getObjects();
            self.canvas.moveTo(objects[objects.length - 1], 1);  // 将首个对象置顶
            //self.canvas.moveTo(objects[0], objects.length-1);  // 将首个对象置顶
        },
        createImage(url, options) {
            options = options || {}
            let canvas = this.canvas;
            let that = this;
            fabric.Image.fromURL(url, function (img) {
                // 添加过滤器
                // img.filters.push(new fabric.Image.filters.Grayscale());
                // 应用过滤器并重新渲染画布执行
                // img.applyFilters(canvas.renderAll.bind(canvas));
                // console.log(img);
                let maxWidth = that.width / 2;
                let width = 0;
                let height = 0;
                width = img.width;
                height = img.height;
                // if (img.width > img.height) {
                //   if (img.width > maxWidth) {
                //     width = maxWidth;
                //     height = (img.height / img.width) * width;
                //   } else {
                //     width = img.width;
                //     height = img.height;
                //   }
                // } else {
                //   if (img.height > maxWidth) {
                //     height = maxWidth;
                //     width = (img.width / img.height) * height;
                //   } else {
                //     width = img.width;
                //     height = img.height;
                //   }
                // }
                if (options && options.width) {
                    width = options.width;
                }
                if (options && options.height) {
                    height = options.height;
                }
                let leftP = that.width / 2;
                let topP = that.height / 2;
                if ((options && options.left) || (options && options.left == 0)) {
                    leftP = options.left + width / 2;
                }
                if ((options && options.top) || (options && options.top == 0)) {
                    topP = options.top + height / 2;
                }
                // console.log(options);
                let imgOptions = Object.assign(options, {
                    // ...options,
                    id: (options && options.id) ? options.id : 'image',
                    left: leftP,
                    top: topP,
                    scaleX: width / img.width,
                    scaleY: height / img.height,
                    originX: 'center',
                    originY: 'center',
                    cornerStrokeColor: 'blue'
                })
                delete imgOptions.width;
                delete imgOptions.height;
                console.log("imgOptions", imgOptions);
                img.set(imgOptions);

                var oldOriginX = img.get('originX');
                var oldOriginY = img.get('originY');
                var center = img.getCenterPoint();
                img.crossOrigin = 'anonymous';
                img.hasControls = true;
                img.hasBorders = true;
                // img.customiseCornerIcons(
                //   {
                //     settings: {
                //       borderColor: '#b4b4b4',
                //       cornerSize: 20,
                //       cornerBackgroundColor: '#FF0000',
                //       cornerShape: 'circle',
                //       cornerPadding: 0
                //     }
                //     tl: {
                //       icon: dotCircleImg
                //     },
                //     tr: {
                //       icon: dotCircleImg
                //     },
                //     bl: {
                //       icon: dotCircleImg
                //     },
                //     br: {
                //       icon: dotCircleImg
                //     },
                //     mb: {
                //       icon: dotCircleImg
                //     },
                //     mt: {
                //       icon: dotCircleImg
                //     },
                //     mr: {
                //       icon: dotCircleImg
                //     },
                //     mtr: {
                //       icon: dotCircleImg
                //     }
                //   },
                //   function () {
                //     canvas.renderAll();
                //   }
                // );
                // img.setControlsVisibility({
                //   bl: true,
                //   br: true,
                //   mb: false,
                //   ml: true,
                //   mr: true,
                //   mt: false,
                //   mtr: true,
                //   tl: true,
                //   tr: true
                // });
                canvas.add(img);
                canvas.renderAll.bind(canvas);
            });
        },
    }

}

</script>

<style lang='scss' scoped>
@media (max-width: 8000px) and (min-width: 1024px) {
    .gooddetail {
        width: 100%;
        overflow: hidden;
        margin: 0px auto;
        padding: 0px;
        box-sizing: border-box;

        .detail-centers {
            width: 980px;
            overflow: hidden;
            margin: 45px auto;
            padding: 0px;
            box-sizing: border-box;

            .goods-btns {
                width: 600px;
                overflow: hidden;
                padding: 0px;
                margin-top: 20px;
                box-sizing: border-box;
                text-align: center;
            }

            .title-top {
                width: 100%;
                overflow: hidden;
                margin: 10px auto;
                padding: 0px;
                font-size: 16px;
                text-align: left;
                font-size: 20px;
                font-weight: 600;
                color: #1a1a1a;
                box-sizing: border-box;
            }

            .goods-fabric {
                width: 100%;
                overflow: hidden;
                margin: 0px auto;
                padding: 0px;
                box-sizing: border-box;

                .left {
                    width: 600px;
                    overflow: hidden;
                    float: left;
                    margin: 0px auto;
                    padding: 0px;
                }

                .right {
                    width: 340px;
                    overflow: hidden;
                    float: right;
                    margin: 0px auto;
                    box-sizing: border-box;

                    .font {
                        width: 100%;
                        overflow: hidden;
                        margin: 5px auto;
                        font-size: 18px;
                        font-weight: 600;
                        color: #1a1a1a;
                    }

                    .items {
                        width: 100%;
                        overflow: hidden;
                        padding-left: 20px;
                        padding-right: 20px;
                        margin: 5px auto;
                        box-sizing: border-box;
                    }
                }
            }

            .detail-top {
                width: 100%;
                overflow: hidden;
                margin: 0px auto;
                padding: 0px;
                box-sizing: border-box;

                .detail-pic {
                    width: 49%;
                    overflow: hidden;
                    float: left;
                    margin: 0px auto;
                    padding: 0px;
                    box-sizing: border-box;
                }

                .detail-title {
                    width: 49%;
                    overflow: hidden;
                    float: right;
                    margin: 0px auto;
                    padding: 0px;
                    box-sizing: border-box;
                    text-align: left;
                    font-size: 20px;
                    font-weight: 600;
                    color: #1a1a1a;

                    .goods-warehouse {
                        width: 100%;
                        overflow: hidden;
                        margin: 12px auto;
                        padding: 0px;
                        box-sizing: border-box;
                        color: #1a1a1a;
                        font: 14px / 1 PingFang SC, system-ui, -apple-system;
                    }

                    .goods-pr {
                        width: 100%;
                        overflow: hidden;
                        margin: 12px auto;
                        text-align: left;
                        padding: 0px;
                        font-weight: 500;
                        color: #f83b4a;
                        line-height: 45px;
                        font-size: 28px;
                        font-weight: 600;
                        vertical-align: middle;
                        white-space: nowrap;

                        .max {
                            font-size: 16px;
                        }
                    }
                }
            }
        }

        .nav-topbar {
            width: 100%;
            overflow: hidden;
            background: #ffe url('/imgs/fade.png') top center repeat-x;
            position: fixed;
            top: 0px;
            left: 0px;
            z-index: 10;

            .mobiles-nav-list {
                display: none;
            }

            .nav-list {
                width: 980px;
                overflow: hidden;
                margin: 0px auto;

                .searchTexts {
                    width: 50%;
                    float: right;
                    overflow: hidden;
                    margin: 6px auto;
                }

                .nav-backs {
                    text-decoration: none;
                    display: block;
                    font-weight: 400;
                    overflow: hidden;
                    color: maroon;
                    line-height: 45px;
                    text-align: center;
                    float: left;
                    cursor: pointer;
                }

                .nav-items {
                    text-decoration: none;
                    display: block;
                    margin-left: 12px;
                    font-weight: 400;
                    overflow: hidden;
                    color: maroon;
                    line-height: 45px;
                    text-align: center;
                    float: left;
                }

                .nav-backs:hover {
                    color: red !important;
                    text-decoration: underline;
                }
            }
        }
    }
}

@media (max-width: 1024px) and (min-width: 320px) {
    .gooddetail {
        width: 100%;
        overflow: hidden;
        margin: 0px auto;
        padding: 0px;
        box-sizing: border-box;

        .detail-centers {
            width: 100%;
            overflow: hidden;
            margin: 40px auto auto auto;
            padding: 0px;
            box-sizing: border-box;

            .title-top {
                width: 98%;
                overflow: hidden;
                margin: 10px auto;
                padding: 0px;
                text-align: left;
                font-size: 18px;
                font-weight: 600;
                color: #1a1a1a;
                box-sizing: border-box;
            }

            .goods-fabric {
                width: 100%;
                overflow: hidden;
                margin: 0px auto;
                padding: 0px;
                box-sizing: border-box;

                .left {
                    width: 100%;
                    overflow: hidden;
                    margin: 0px auto;
                    padding: 0px;
                    box-sizing: border-box;
                }

                .right {
                    width: 100%;
                    overflow: hidden;
                    margin: 0px auto;
                    padding: 0px;
                    box-sizing: border-box;

                    .font {
                        width: 100%;
                        overflow: hidden;
                        margin: 5px auto;
                        font-size: 18px;
                        font-weight: 600;
                        color: #1a1a1a;
                    }

                    .items {
                        width: 100%;
                        overflow: hidden;
                        padding-left: 15px;
                        padding-right: 15px;
                        margin: 5px auto;
                        box-sizing: border-box;
                    }
                }
            }

            .goods-btns {
                width: 100%;
                overflow: hidden;
                padding: 0px;
                margin: 10px auto 25px auto;
                box-sizing: border-box;
                text-align: center;
            }

            .goods-fabric {
                width: 100%;
                overflow: hidden;
                margin: 10px auto;
                padding: 10px;
                box-sizing: border-box;
            }


            .detail-top {
                width: 98%;
                overflow: hidden;
                margin: 0px auto;
                padding: 0px;
                box-sizing: border-box;

                .detail-pic {
                    width: 49%;
                    overflow: hidden;
                    float: left;
                    margin: 10px auto;
                    padding: 0px;
                    box-sizing: border-box;
                }

                .detail-title {
                    width: 49%;
                    overflow: hidden;
                    float: right;
                    margin: 5px auto;
                    padding: 0px;
                    box-sizing: border-box;
                    text-align: left;
                    font-size: 18px;
                    font-weight: 600;
                    color: #1a1a1a;

                    .goods-warehouse {
                        width: 100%;
                        overflow: hidden;
                        margin: 12px auto;
                        padding: 0px;
                        box-sizing: border-box;
                        color: #1a1a1a;
                        font: 14px / 1 PingFang SC, system-ui, -apple-system;
                    }

                    .goods-pr {
                        width: 100%;
                        overflow: hidden;
                        margin: 12px auto;
                        text-align: left;
                        padding: 0px;
                        font-weight: 500;
                        color: #f83b4a;
                        line-height: 45px;
                        font-size: 28px;
                        font-weight: 600;
                        vertical-align: middle;
                        white-space: nowrap;

                        .max {
                            font-size: 16px;
                        }
                    }
                }
            }

        }

        .nav-topbar {
            width: 100%;
            overflow: hidden;
            position: fixed;
            top: 0px;
            left: 0px;
            z-index: 10;
            background: url('/imgs/fade.png') top center repeat-x;

            .mobiles-nav-list {
                width: 100%;
                overflow: hidden;
                box-sizing: border-box;
                padding: 0px;
                margin: 0px auto;

                .nav-backs {
                    text-decoration: none;
                    display: block;
                    margin-left: 12px;
                    font-weight: 400;
                    overflow: hidden;
                    color: maroon;
                    line-height: 45px;
                    text-align: center;
                    float: left;
                }

                .nav-items {
                    text-decoration: none;
                    display: block;
                    margin-left: 12px;
                    font-weight: 400;
                    overflow: hidden;
                    color: maroon;
                    line-height: 45px;
                    text-align: center;
                    float: left;
                }
            }

            .nav-list {
                display: none;
            }
        }
    }
}
</style>
